module.exports = function() {
  return new Worker(__webpack_public_path__ + "36fe3a77bacc5095d38a.worker.js");
};